<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="goBack($event)" defaultHref="my-teams"></ion-back-button>
    </ion-buttons>
    <ion-item lines="none" color="none">
        @if(user?.profile_image){
            <ion-avatar slot="start" class="header-avatar">
            <img style="width: auto" [src]="user?.profile_image?.original" />
          </ion-avatar>
        } @else {
            <ion-avatar slot="start">
                <img class="avatarImage" [src]="avatarImage" />
            </ion-avatar>
        }
        <ion-label *ngIf="!isLoading">
            {{ user.first_name }} {{ user.last_name }}
        </ion-label>
    </ion-item>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment [value]="segment" (ionChange)="segmentChange($event)">
      <ion-segment-button value="matches">
        <ion-label>{{ 'Matches' | translate }}</ion-label>
      </ion-segment-button>

      <ion-segment-button value="details">
        <ion-label>{{ 'Details' | translate }}</ion-label>
      </ion-segment-button>

      @if(allowAddPlayerNumber){
        <ion-segment-button value="jerseyNumber">
            <ion-label>{{ 'Player Number' | translate }}</ion-label>
        </ion-segment-button>
      }
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="!isLoading && segment === 'details'">
    <ion-list class="content-width">
      <ion-item>
        <ion-label>{{ 'Name' | translate }}</ion-label>
        {{ user.last_name?.toUpperCase() }}, {{ user.first_name }}
      </ion-item>

      <ion-item>
        <ion-label>{{ 'Gender' | translate }}</ion-label>
        {{ user.biographicalInformation?.sex === 'M' ? 'Male' : 'Female' }}
      </ion-item>
      @if(user.biographicalInformation?.height){
        <ion-item>
          <ion-label>{{ 'Height' | translate }}</ion-label>
          {{ user.biographicalInformation?.height }}
        </ion-item>
      }
      @if(user.biographicalInformation?.age){
        <ion-item>
         <ion-label>{{ 'Age' | translate }}</ion-label>
        {{ user.biographicalInformation?.age }}
      </ion-item>
      }

      <ion-item>
         <ion-label>{{ 'Hometown' | translate }}</ion-label>
        {{ user?.hometown }} 
      </ion-item>

      <!-- <ion-item>
        <ion-label {{ 'Banner image for web' | translate }}</ion-label>
        <div class="pt-5 pb-5"><img  width= "100px" [src]="user?.banner_image_web?.original"/></div> 
      </ion-item>
      <ion-item>
        <ion-label {{ 'Banner image for mobile' | translate }}</ion-label>
        <div class="pt-5 pb-5"> <img  width= "100px" [src]="user?.banner_image_mobile?.original"/></div> 
      </ion-item> -->

      <ion-item>
         <ion-label>{{ 'Action shot Image' | translate }}</ion-label>
        <div class="pt-5 pb-5"> <img  width= "100px" [src]="user?.action_shot_image?.original"/></div> 
      </ion-item>

      <ion-item>
         <ion-label>{{ 'Bio' | translate }}</ion-label>
       <div class="bio pt-5 pb-5">{{ user?.about}} </div> 
      </ion-item>

      <ng-container *ngIf="user.social_media_urls">
        <ion-item>
          <ion-label class="ion-text-center" style="font-weight: bold;">{{ 'Social Media Links' | translate }}</ion-label>
        </ion-item>
      
      
        <ion-item>
          <ion-label>{{ 'Facebook' | translate }}</ion-label>
          <a  *ngIf="user.social_media_urls.facebook" [href]="user.social_media_urls.facebook" target="_blank">{{ user.social_media_urls.facebook }}</a>
        </ion-item>
      
        <ion-item>
          <ion-label>{{ 'Instagram' | translate }}</ion-label>
          <a *ngIf="user.social_media_urls.instagram" [href]="user.social_media_urls.instagram" target="_blank">{{ user.social_media_urls.instagram }}</a>
        </ion-item>
      
        <ion-item>
          <ion-label>{{ 'X' | translate }}</ion-label>
          <a *ngIf="user.social_media_urls.x" [href]="user.social_media_urls.x" target="_blank">{{ user.social_media_urls.x }}</a>
        </ion-item>
      
        <ion-item>
          <ion-label>{{ 'TikTok' | translate }}</ion-label>
          <a *ngIf="user.social_media_urls.tiktok" [href]="user.social_media_urls.tiktok" target="_blank">{{ user.social_media_urls.tiktok }}</a>
        </ion-item>
      
        <ion-item>
          <ion-label>{{ 'YouTube' | translate }}</ion-label>
          <a *ngIf="user.social_media_urls.youtube" [href]="user.social_media_urls.youtube" target="_blank">{{ user.social_media_urls.youtube }}</a>
        </ion-item>
      
        <ion-item>
          <ion-label>{{ 'LinkedIn' | translate }}</ion-label>
          <a *ngIf="user.social_media_urls.linkedin" [href]="user.social_media_urls.linkedin" target="_blank">{{ user.social_media_urls.linkedin }}</a>
        </ion-item>
      </ng-container>
      
      <!-- <ion-item>
                <ion-label>Created</ion-label>
                {{ user.created_at | date: 'longDate'}}
            </ion-item> -->

      <!-- <ion-item-group *ngIf="user.biographicalInformation">
                <ion-item-divider color="light">
                    <ion-label>Rankings</ion-label>
                </ion-item-divider>

                <ion-item *ngIf="user.biographicalInformation.national">
                    <ion-label>{{ 'National' | translate }}</ion-label>
                    {{ user.biographicalInformation.national }}
                </ion-item>
                <ion-item *ngIf="user.biographicalInformation.itf">
                    <ion-label>{{ 'ITF' | translate }}</ion-label>
                    {{ user.biographicalInformation.itf }}
                </ion-item>
                <ion-item *ngIf="user.biographicalInformation.atpwta">
                    <ion-label>{{ 'ATP/WTA' | translate }}</ion-label>
                    {{ user.biographicalInformation.atpwta }}
                </ion-item>
                <ion-item *ngIf="user.biographicalInformation.utr">
                    <ion-label>{{ 'UTR' | translate }}</ion-label>
                    {{ user.biographicalInformation.utr }}
                </ion-item>
            </ion-item-group> -->
    </ion-list>

    @if((isOwner && !isTeamITA) || isMyValidPlayer){
        <div class="content-width">
          <ion-row>
            <ion-col size="6">
              <ion-button
                (click)="editPlayer()"
                expand="block"
                fill="clear"
                translate
              >
                {{'Edit' | translate}}
              </ion-button>
            </ion-col>

            <ion-col size="6">
              <ion-button
                color="danger"
                (click)="deletePlayer()"
                expand="block"
                fill="clear"
                translate
              >
                {{'Remove' | translate}}
              </ion-button>
            </ion-col>
          </ion-row>
        </div>
    }
  </ng-container>

  <app-match-list
    *ngIf="!isLoading && segment === 'matches'"
    [playerId]="this.user._id"
  ></app-match-list>

    @if(allowAddPlayerNumber){
        <app-player-number *ngIf="!isLoading && segment === 'jerseyNumber'" [team]="team" [user]="user"></app-player-number>
    }
</ion-content>